export const AccountTypes = {
  simple: 'simple',
  enterprise: 'enterprise',
  internal: 'internal',
  demo: 'demo',
  sandbox: 'sandbox',
};

export const NonCustomerAccountTypes = [
  AccountTypes.internal,
  AccountTypes.demo,
  AccountTypes.sandbox,
];
